// extracted by mini-css-extract-plugin
export default {"blockFeedback":"FeedBack_blockFeedback__0Bp3P"};